import { createApiActions } from '../../../utils/api-state';
import { GetCreditHealthRequest } from '../models/credit-health.model';
import { CreditHealthState } from './credit-health.reducer';

export const creditHealthActions = createApiActions<GetCreditHealthRequest, CreditHealthState>(
  '[Credit Health] Get CreditHealth'
);
